var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.asset
    ? _c("figure", { staticClass: "media-gallery-asset" }, [
        _c(
          "div",
          {
            staticClass: "media-gallery-assets__image",
            on: { click: _vm.handleDetail },
          },
          [
            _vm.asset.thumbnail
              ? _c("img", { attrs: { src: _vm.asset.thumbnail, alt: "" } })
              : _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 160 160",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { fill: "none", "fill-rule": "evenodd" } },
                      [
                        _c("path", {
                          attrs: {
                            fill: "#CCC",
                            "fill-rule": "nonzero",
                            d: "M93 29H39v103h81V56z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            fill: "#FFF",
                            "fill-rule": "nonzero",
                            d: "M93 34v22h22v70H44V34z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: { fill: "#ABABAB", d: "M71 94h59v22H71z" },
                        }),
                        _vm._v(" "),
                        _c(
                          "text",
                          {
                            attrs: {
                              fill: "#000",
                              "font-size": "15",
                              "font-weight": "300",
                              transform: "translate(71 94)",
                            },
                          },
                          [
                            _c("tspan", { attrs: { x: "16", y: "17" } }, [
                              _vm._v(_vm._s(_vm.asset.meta_type.toUpperCase())),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
          ]
        ),
        _vm._v(" "),
        _c(
          "figcaption",
          { staticClass: "spacer-top-21" },
          [
            _c("global-input-checkbox", {
              attrs: {
                label: _vm.checkboxLabel,
                value: _vm.isSelected,
                "label-suffix": _vm.suffix,
              },
              on: {
                input: function ($event) {
                  return _vm.$store.dispatch(
                    "toggleAssetSelection",
                    _vm.asset.id
                  )
                },
              },
            }),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }